"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find-index");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _lastMileDeliveryWellcome = require("@/mixins/last-mile-delivery-wellcome/last-mile-delivery-wellcome");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDOrderFilterTagComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDOrderFilterTagComponent, _Mixins);

  var _super = _createSuper(LMDOrderFilterTagComponent);

  function LMDOrderFilterTagComponent() {
    (0, _classCallCheck2.default)(this, LMDOrderFilterTagComponent);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(LMDOrderFilterTagComponent, [{
    key: "onOrderFiltersChanges",
    value: function onOrderFiltersChanges(newVal, oldval) {
      if (newVal.length > 0) {
        this.$selectedOrders = []; // Reset the selected orders

        this.$pagination = _objectSpread(_objectSpread({}, this.$pagination), {}, {
          currentPage: 1
        });
        this.$getUnassignedOrders();
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "handleCloseTag",
    value: function () {
      var _handleCloseTag = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(filter) {
        var index, tmpArr;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                index = this.helper.findIndex(this.$orderFilters, {
                  key: filter.key,
                  value: filter.value
                });
                tmpArr = this.helper.cloneDeep(this.$orderFilters);
                tmpArr.splice(index, 1);
                this.$orderFilters = tmpArr;
                _context.next = 6;
                return this.$getUnassignedOrders();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleCloseTag(_x) {
        return _handleCloseTag.apply(this, arguments);
      }

      return handleCloseTag;
    }()
  }, {
    key: "filterOrderFilters",
    get: function get() {
      if (this.$props.type === 'manual') {
        return this.$orderFilters;
      } else {
        if (this.$orderFilters.length >= 1) {
          return this.$orderFilters.filter(function (ofilter) {
            return !ofilter['exactValue'] || ofilter['exactValue'] !== true;
          });
        } else {
          return [];
        }
      }
    }
  }, {
    key: "hasOrderFilters",
    get: function get() {
      if (this.$props.type === 'manual' || this.$props.type === 'schedule') {
        return this.$orderFilters.length >= 1;
      } else {
        if (this.$orderFilters.length >= 1) {
          return !this.$orderFilters.every(function (ofilter) {
            return ofilter['exactValue'] === true;
          });
        } else {
          return false;
        }
      }
    }
  }, {
    key: "removeOrderFilters",
    value: function removeOrderFilters() {
      this.$orderFilters = [];
      this.$getUnassignedOrders();
    }
  }]);
  return LMDOrderFilterTagComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDeliveryWellcome.LastMileDeliveryMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: 'manual'
})], LMDOrderFilterTagComponent.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$orderFilters', {
  deep: true
})], LMDOrderFilterTagComponent.prototype, "onOrderFiltersChanges", null);
LMDOrderFilterTagComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDOrderFilterTagComponent',
  components: {
    'el-tag': _elementUi.Tag,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-button': _elementUi.Button,
    'el-tooltip': _elementUi.Tooltip
  }
})], LMDOrderFilterTagComponent);
var _default = LMDOrderFilterTagComponent;
exports.default = _default;